<div class="toolbar-grid-button" [class.disabled]="!hasAccess" (click)="onSelect(6)">
    @if (!hasAccess) {
        <span class="badge badge-paid" [class]="badgeTariffClass">&nbsp;</span>
    }
    <div class="grid-preview-img">
        <img src="./assets/img/websites/elements-icon/lpc-tab-icon-1.svg" />
    </div>
</div>
<div class="toolbar-grid-button" [class.disabled]="!hasAccess" (click)="onSelect(0)">
    @if (!hasAccess) {
        <span class="badge badge-paid" [class]="badgeTariffClass">&nbsp;</span>
    }
    <div class="grid-preview-img">
        <img src="./assets/img/websites/elements-icon/lpc-tab-icon-2.svg" />
    </div>
</div>
<div class="toolbar-grid-button" [class.disabled]="!hasAccess" (click)="onSelect(3)">
    @if (!hasAccess) {
        <span class="badge badge-paid" [class]="badgeTariffClass">&nbsp;</span>
    }
    <div class="grid-preview-img">
        <img src="./assets/img/websites/elements-icon/lpc-tab-icon-3.svg" />
    </div>
</div>
<div class="toolbar-grid-button" [class.disabled]="!hasAccess" (click)="onSelect(4)">
    @if (!hasAccess) {
        <span class="badge badge-paid" [class]="badgeTariffClass">&nbsp;</span>
    }
    <div class="grid-preview-img">
        <img src="./assets/img/websites/elements-icon/lpc-tab-icon-4.svg" />
    </div>
</div>
<div class="toolbar-grid-button" [class.disabled]="!hasAccess" (click)="onSelect(5)">
    @if (!hasAccess) {
        <span class="badge badge-paid" [class]="badgeTariffClass">&nbsp;</span>
    }
    <div class="grid-preview-img">
        <img src="./assets/img/websites/elements-icon/lpc-tab-icon-5.svg" />
    </div>
</div>
<div class="toolbar-grid-button" [class.disabled]="!hasAccess" (click)="onSelect(1)">
    @if (!hasAccess) {
        <span class="badge badge-paid" [class]="badgeTariffClass">&nbsp;</span>
    }
    <div class="grid-preview-img">
        <img src="./assets/img/websites/elements-icon/lpc-tab-icon-6.svg" />
    </div>
</div>
